import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";

const CATEGORIES = ["All", "Precision Medicine", "Herbal Medicine", "Indigenous Science", "Nutritional Medicine", "Environmental Medicine", "Agroecology", "Indigenous Farming"];

export default function Library() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/library", { params: cat !== "All" ? { category: cat } : {} }).then((r) => setItems(r.data));
  }, [cat]);

  return (
    <div className="min-h-screen bg-[#F9F6F0]">
      <Header />
      <section className="px-6 sm:px-12 lg:px-20 pt-20 pb-10 max-w-6xl mx-auto">
        <p className="label-eyebrow mb-3">The Library</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2D322B] max-w-3xl">
          Essays from many lineages.
        </h1>
        <p className="mt-6 text-[#5C6359] max-w-2xl">
          Reading the body through two lenses at once — lab and leaf, biomarker and breath.
        </p>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="category-filters">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`category-${c.toLowerCase().replace(/ /g, "-")}`}
              className={`px-5 py-2 rounded-full text-xs uppercase tracking-widest border transition-colors ${cat === c ? "bg-[#2D322B] text-[#F9F6F0] border-[#2D322B]" : "border-[#D1C7B8] text-[#2D322B] hover:border-[#C05C42]"}`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      <section className="px-6 sm:px-12 lg:px-20 pb-24 max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((c) => (
          <Link to={`/library/${c.id}`} key={c.id} className="group block rounded-3xl overflow-hidden bg-[#F1ECE4] border border-[#D1C7B8] hover:-translate-y-1 transition-transform" data-testid={`library-card-${c.id}`}>
            <div className="h-56 overflow-hidden bg-[#D1C7B8]">
              <img src={c.image} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6">
              <div className="flex items-center justify-between">
                <p className="text-xs uppercase tracking-widest text-[#C05C42]">{c.category}</p>
                <p className="text-xs text-[#5C6359]">{c.reading_time}</p>
              </div>
              <h3 className="font-serif text-2xl text-[#2D322B] mt-3 leading-snug">{c.title}</h3>
              <p className="text-sm text-[#5C6359] mt-3 leading-relaxed">{c.excerpt}</p>
              <p className="mt-4 text-xs uppercase tracking-widest text-[#5C6359]">Tradition · {c.tradition}</p>
            </div>
          </Link>
        ))}
      </section>
      <Footer />
    </div>
  );
}
